module.exports = "/assets/4c652d7724d8ac6091b4a383b12f96dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UT.png
// module id = 3022
// module chunks = 0